import { useCallback, useEffect, useRef, useState } from 'react';

interface RecognitionLike {
  lang: string;
  interimResults: boolean;
  continuous: boolean;
  onresult: ((e: { results: ArrayLike<ArrayLike<{ transcript: string }>> }) => void) | null;
  onend: (() => void) | null;
  onerror: ((e?: { error?: string }) => void) | null;
  start: () => void;
  stop: () => void;
}
type RecognitionCtor = new () => RecognitionLike;

function getCtor(): RecognitionCtor | undefined {
  if (typeof window === 'undefined') return undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  return w.SpeechRecognition || w.webkitSpeechRecognition;
}

// Ditado por voz: o texto reconhecido vai para o campo, quem envia é o usuário.
export function useSpeechInput() {
  const suportado = !!getCtor();
  const [ouvindo, setOuvindo] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const rec = useRef<RecognitionLike | null>(null);

  useEffect(() => () => { rec.current?.stop(); }, []);

  const parar = useCallback(() => { rec.current?.stop(); }, []);

  const iniciar = useCallback((onTexto: (texto: string) => void) => {
    const Ctor = getCtor();
    if (!Ctor || rec.current) return;
    const r = new Ctor();
    r.lang = 'pt-BR';
    r.interimResults = false;
    r.continuous = false;
    r.onresult = (e) => {
      const texto = Array.from(e.results).map((x) => x[0]?.transcript ?? '').join(' ').trim();
      if (texto) onTexto(texto);
    };
    const fim = () => { rec.current = null; setOuvindo(false); };
    r.onend = fim;
    r.onerror = (e) => {
      if (e?.error === 'not-allowed') setErro('Microfone bloqueado no navegador.');
      fim();
    };
    rec.current = r;
    setErro(null);
    setOuvindo(true);
    try { r.start(); } catch { fim(); }
  }, []);

  return { suportado, ouvindo, erro, iniciar, parar };
}
